/*
 * AbTestModuleLoader
 * Framework level class not to be modified for AbTest implementations
 * */
import { CoreAbTestRunner } from './CoreAbTestRunner';

/*
 * This constant promise is required to map classes accordingly for Core-UI AbTest Classes
 * DO NOT REMOVE
 * */
const ImportPromise = (moduleName) => {
    return import(`../testClasses/${moduleName}`);
};

export class AbTestModuleLoader extends CoreAbTestRunner {
    constructor({ importPromise = ImportPromise, isAA = false } = {}) {
        super({ isAA });
        this.init(importPromise);
    }

    init = (importPromise) => {
        /*
         * Imports and runs experiments at runtime
         * as defined on XHRABTestModules at the CBS.AbTestsConfigs registry
         * When a module is unavailable log the error and run those available
         * */
        Promise.all(
            Object.keys(this.experimentsModules).map(async (moduleKey) => {
                const expModule = this.experimentsModules[moduleKey];
                if (expModule.isXHR) {
                    try {
                        const module = await importPromise(expModule['name']);
                        return new module[moduleKey](expModule);
                    } catch (e) {
                        console.warn(e.message);
                        return null;
                    }
                }
            }),
        ).then((modules) => {
            this.experimentsSetup({
                experimentsList: modules.filter(function (val) {
                    return Boolean(val);
                }),
            });
        });
    };
}
